import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserControllerService } from 'src/app/services/user-controller.service';

@Component({
  selector: 'app-canditates-sidenav',
  templateUrl: './canditates-sidenav.component.html',
  styleUrls: ['./canditates-sidenav.component.scss']
})
export class CanditatesSidenavComponent implements OnInit {

  constructor(private _candidates: UserControllerService,
    private router: Router) { }
  tokeninfo = <any>JSON.parse(atob(sessionStorage.getItem('token')!.split('.')[1]))
  role=this.tokeninfo.role
  candidates;
  ngOnInit(): void {
    this._candidates.getCandidates({}).subscribe(resolve => {
      this.candidates = resolve;
    })
  }

  onSelect(candidate_id) {
    this.router.navigate(['/homeuser/candidate', candidate_id]).then(() => {
      window.location.reload();
    }).catch(e => { console.log(e) })
  }

}
